import apiClient from '../../../../shared/api/apiClient';
import type { 
  FeePaymentResponseDto, 
  RecordCashPaymentDto, 
  FeePaymentReceiptDto,
  GetFeePaymentsDto,
  PaginatedFeePaymentResponseDto
} from '../types/fee-payment.dto';
import type { StudentFeeScheduleLineDto } from '../types/student-fees.dto';

export const getFeePayments = async (params?: GetFeePaymentsDto): Promise<PaginatedFeePaymentResponseDto> => {
  const { data } = await apiClient.get('/fee-payments', { params: params as Record<string, unknown> });
  return data;
};

export const getPaymentById = async (id: string): Promise<FeePaymentResponseDto> => {
  const { data } = await apiClient.get(`/fee-payments/${id}`);
  return data;
};

export const getStudentDues = async (studentId: string, params?: Record<string, unknown>): Promise<StudentFeeScheduleLineDto[]> => {
  const { data } = await apiClient.get(`/fee-payments/students/${studentId}/dues`, { params });
  if (Array.isArray(data)) return data;
  if (data && Array.isArray((data as any).data)) return (data as any).data;
  return [];
};

export const recordCashPayment = async (payload: RecordCashPaymentDto): Promise<FeePaymentResponseDto> => {
  const { data } = await apiClient.post('/fee-payments/cash', payload);
  return data;
};

export const getPaymentReceipt = async (id: string): Promise<FeePaymentReceiptDto> => {
  const { data } = await apiClient.get(`/fee-payments/${id}/receipt`);
  return data;
};

import { parseResponseToPdfBlob } from '../utils/generateFeeReceiptPDF';

export const downloadReceiptPdf = async (id: string): Promise<Blob> => {
  try {
    const { data } = await apiClient.get(`/fee-reports/student/${encodeURIComponent(id)}/pdf`, {
      responseType: 'blob',
    });
    return await parseResponseToPdfBlob(data);
  } catch {
    // fallback to transaction receipt endpoint
  }

  const { data } = await apiClient.get(`/fee-payments/${id}/receipt.pdf`, {
    responseType: 'blob',
  });
  return await parseResponseToPdfBlob(data);
};
